import React, { ReactNode } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, PaperProps } from '@material-ui/core';
import classNames from 'classnames';

interface SummarySectionContainerProps extends PaperProps {
  children: ReactNode | ReactNode[];
}

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(3),
  },
}));

export const SummarySectionContainer = ({
  children,
  className,
  ...rest
}: SummarySectionContainerProps) => {
  const classes = useStyles();

  const paperClasses = classNames(classes.container, className);

  return (
    <Paper variant="outlined" className={paperClasses} {...rest}>
      {children}
    </Paper>
  );
};
